import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const productionLineApi = createApi({
  reducerPath: 'productionLineApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['ProductionLine'],
  endpoints: (builder) => ({
    getProductionLines: builder.query<unknown[], void>({
      query: () => 'production-lines',
      providesTags: ['ProductionLine'],
    }),
    getProductionLine: builder.query<unknown, string>({
      query: (id) => `production-lines/${id}`,
      providesTags: ['ProductionLine'],
    }),
    createProductionLine: builder.mutation<unknown, Record<string, unknown>>({
      query: (body) => ({ url: 'production-lines', method: 'POST', body }),
      invalidatesTags: ['ProductionLine'],
    }),
    updateProductionLine: builder.mutation<unknown, { id: string; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({ url: `production-lines/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['ProductionLine'],
    }),
    deleteProductionLine: builder.mutation<void, string>({
      query: (id) => ({ url: `production-lines/${id}`, method: 'DELETE' }),
      invalidatesTags: ['ProductionLine'],
    }),
  }),
});

export const {
  useGetProductionLinesQuery,
  useGetProductionLineQuery,
  useCreateProductionLineMutation,
  useUpdateProductionLineMutation,
  useDeleteProductionLineMutation,
} = productionLineApi;
